export default {
  zh: {
    event_coming_soon: '该活动即将在您国家开启，敬请期待~',
    global_star: '国家竞技',
    hoby_2024_global_star: 'HOBY 2024 全球之星',
    last_week_global_star: '上周全球之星',
    event_gift: '活动礼物',
    event_gift_description1: '送出祖国的礼物，为祖国加油',
    national_star: '本国助威榜',
    cheer_rewards: '为国助威',
    cheer_rewards2: '为国助威',
    this_week_global_star: '本周全球之星',
    this_week_national_star: '本周国家之星',
    rules: '规则',
    rewards: '奖励',
    rules_ewards: '规则&奖励',
    global_star_ranking: '全球之星排名',
    global_star_ranking_description1: '1.送出活动礼物，为你的国家助威。',
    global_star_ranking_description2: '2.根据活动期间本国用户送出的活动礼物数量排名。',
    global_star_rewards: '全球之星奖励',
    global_star_rewards_description1: '1.活动期间送的活动礼物越多，获得的奖励越丰厚。',
    global_star_rewards_description2: '2. 全球之星排名前3的国家中突出贡献用户可获得勋章，VIP，头饰，座驾等奖励。',
    national_star_ranking: '国家之星排名',
    national_star_ranking_description1: '1.根据活动期间送出的活动礼物数量排名。',
    Other: '其他',
    Other_description1: '1.若平台发现用户违反规定，平台有权删除用户活动数据。',
    Other_description2: '2.本次活动的解释权归Hoby所有，本次活动与苹果无关。',
    top1_country: 'TOP1国家',
    top2_country: 'TOP2国家',
    top3_country: 'TOP3国家',
    top1_user: 'TOP1用户',
    top2_user: 'TOP2用户',
    top3_user: 'TOP3用户',
    cheer_rewards_description1: '送出下方礼物完成助威',
    current_gift_quantity: '当前赠送数量:{0}',
    cheer_rewards_description2: '送出{0}个当前礼物可解锁下方奖励',
    receive: '获取',
    received: '已获取',
    certificate: '证书',
    certificate_description1: '尊敬的{0}：',
    certificate_description2:
      '您的热情与奉献是国家荣耀的璀璨光芒。在这充满激情的竞争中，您的行动展现了对国家的深深热爱与坚定支持。此刻，我们怀着无比的敬意，为您送上这份助威荣耀之礼。',
    certificate_description3: '愿您手中的国旗，能永远飘扬在您心中，激励您为{0}的辉煌继续贡献力量！',
    toast_msg: '领取失败，请稍后重试',
    no_gift: '该活动即将在您的国家推出，敬请期待~',
    days: '{0} 天',
    stage_1: '阶段1',
    stage_2: '阶段2',
    stage_3: '阶段3',
    time_days: '天',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒'
  },
  ar: {
    event_coming_soon: 'سيبدأ هذا الحدث في بلدك قريبًا، لذا ترقبوا ~',
    global_star: 'النجم العالمي',
    hoby_2024_global_star: 'هوبي 2024 النجم العالمي',
    last_week_global_star: 'النجم العالمي الاسبوع الماضي',
    event_gift: 'هدية النشاط',
    event_gift_description1: 'إرسال هدية بلدك لتهتف لبلدك',
    national_star: 'النجمة الوطنية',
    cheer_rewards: 'مكافات  الهتاف',
    cheer_rewards2: 'مكافات  الهتاف',
    this_week_global_star: 'النجمة الوطنية هذا الاسبوع',
    this_week_national_star: 'النجم الوطني لهذا الأسبوع',
    rules: 'القواعد',
    rewards: 'المكافآت',
    rules_ewards: 'القواعد والمكافآت',
    global_star_ranking: 'ترتيب النجمة الوطنية',
    global_star_ranking_description1: '1. إرسال هدايا النشاط لتشجيع بلدك.',
    global_star_ranking_description2:
      '2. الترتيب يعتمد على عدد هدايا النشاط التي أرسلها المستخدمون من بلدانهم الأصلية خلال الحدث.',
    global_star_rewards: 'مكافآت النجم العالمي',
    global_star_rewards_description1:
      '1. كلما زاد عدد هدايا الحدث التي ترسلها خلال الحدث، زادت المكافآت السخية التي ستحصل عليها.',
    global_star_rewards_description2:
      '2. يمكن للمستخدمين الذين يقدمون مساهمات بارزة في أعلى 3 دول في  ترتيب النجم العالمي الحصول على الميداليات وكبار الشخصيات وأغطية الرأس والسيارات والمكافآت الأخرى.',
    national_star_ranking: 'ترتيب النجم الوطني',
    national_star_ranking_description1: '1. الترتيب يعتمد على عدد هدايا الحدث المقدمة خلال الحدث.',
    Other: 'آخر',
    Other_description1: '1. إذا اكتشفت المنصة أن أحد المستخدمين قد انتهك اللوائح، يحق للمنصة حذف بيانات نشاط المستخدم.',
    Other_description2: '2. يعود حق تفسير هذا الحدث إلى Yayya، وليس لهذا الحدث أي علاقة بشركة Apple.',
    top1_country: 'الدول TOP1',
    top2_country: 'الدول TOP2',
    top3_country: 'دول TOP3',
    top1_user: 'مستخدمي TOP1',
    top2_user: 'مستخدمي TOP2',
    top3_user: 'مستخدمي TOP3',
    cheer_rewards_description1: 'أرسل الهدايا أدناه لإكمال الهتاف الخاص بك',
    current_gift_quantity: 'كمية الهدية الحالية: {0}',
    cheer_rewards_description2: 'أرسل {0} هدايا حالية لتحصل على المكافآت أدناه',
    receive: 'استلام',
    received: 'تم  استلام',
    certificate: 'شهادة',
    certificate_description1: 'محترم {0}:',
    certificate_description2:
      'إن شغفكم وتفانيكم هما الضوء الساطع للمجد الوطني. في هذه المنافسة الشغوفة، تُظهر أفعالك حبك العميق ودعمك الثابت لبلدك. في هذه اللحظة، وبكل احترام، نرسل لك مكافات البهجة والمجد هذه.',
    certificate_description3:
      'أتمنى أن يرفرف العلم الوطني الذي بين يديك في قلبك إلى الأبد، ويلهمك لمواصلة المساهمة في مجد {0}!',
    toast_msg: 'فشل التجميع، يرجى المحاولة مرة أخرى لاحقًا',
    no_gift: 'سيتم إطلاق هذا الحدث في بلدك قريبًا، من فضلك ترقبوا ~',
    days: '{0} يوم',
    stage_1: 'المرحلة 1',
    stage_2: 'المرحلة 2',
    stage_3: 'المرحلة 3',
    time_days: 'يوم',
    hours: 'ساعة',
    minutes: 'دقيقة',
    seconds: 'ثوان'
  },
  en: {
    event_coming_soon: 'This event will be launched in your country soon, please stay tuned~',
    global_star: 'Global Star',
    hoby_2024_global_star: 'HOBY 2024 Global Star',
    last_week_global_star: "Last week's global star",
    event_gift: 'Activity Gift',
    event_gift_description1: "Send your country's gift to cheer for your country",
    national_star: 'National Star',
    cheer_rewards: 'Cheer<br />Rewards',
    cheer_rewards2: 'Cheer Rewards',
    this_week_global_star: "This week's global star",
    this_week_national_star: "This week's national star",
    rules: 'Rules',
    rewards: 'Rewards',
    rules_ewards: 'Rules & Rewards',
    global_star_ranking: 'Global Star Ranking',
    global_star_ranking_description1: '1. Send event gifts to cheer for your country.',
    global_star_ranking_description2:
      '2. Ranking based on the number of event gifts sent by domestic users during the event.',
    global_star_rewards: 'Global Star Rewards',
    global_star_rewards_description1:
      '1. The more event gifts you send during the event, the more generous rewards you will get.',
    global_star_rewards_description2:
      '2. Users who make outstanding contributions in the top 3 countries of the Global Star ranking can receive medals, VIP, headwear, cars and other rewards.',
    national_star_ranking: 'National Star Ranking',
    national_star_ranking_description1: '1. Ranking based on the number of gifts given during the event.',
    Other: 'Other',
    Other_description1:
      "1. If the platform finds that a user has violated the regulations, the platform has the right to delete the user's activity data.",
    Other_description2: '2. Yayya reserves the right to interpret this event. This event has nothing to do with Apple.',
    top1_country: 'TOP1 Country',
    top2_country: 'TOP2 Country',
    top3_country: 'TOP3 Country',
    top1_user: 'TOP1 User',
    top2_user: 'TOP2 User',
    top3_user: 'TOP3 User',
    cheer_rewards_description1: 'Send the following gift to complete the cheer',
    current_gift_quantity: 'Current gift quantity given: {0}',
    cheer_rewards_description2: 'Send {0} current gifts to unlock the following rewards',
    receive: 'Receive',
    received: 'Received',
    certificate: 'Certificate',
    certificate_description1: 'Dear {0}:',
    certificate_description2:
      'Your passion and dedication are the shining light of national glory. In this passionate competition, your actions have demonstrated your deep love and firm support for the country. At this moment, we present this gift of cheering and glory to you with great respect.',
    certificate_description3:
      'May the national flag in your hand always fly in your heart and inspire you to continue to contribute to the glory of {0}!',
    toast_msg: 'Failed to collect, please try again later',
    no_gift: 'This event will be launched in your country soon, please stay tuned~',
    days: '{0} days',
    stage_1: 'Stage1',
    stage_2: 'Stage2',
    stage_3: 'Stage3',
    time_days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  },
  tr: {
    event_coming_soon: 'Bu etkinlik yakında ülkenizde başlayacak, bu yüzden bizi izlemeye devam edin~',
    global_star: 'Global Yıldız ',
    hoby_2024_global_star: 'HOBY 2024 Global Yıldız ',
    last_week_global_star: 'Geçen haftanın Global Yıldızı ',
    event_gift: 'Etkinlik Hediyesi ',
    event_gift_description1: 'Ülkenizin en üst sıralarda olması için ülkenizin hediyesini gönderin',
    national_star: 'Ulusal Yıldız',
    cheer_rewards: 'Tezahürat<br />Ödülleri',
    cheer_rewards2: 'Tezahürat Ödülleri',
    this_week_global_star: 'Bu haftanın global yıldızı ',
    this_week_national_star: 'Bu haftanın Ulusal Yıldız',
    rules: 'Kurallar',
    rewards: 'Ödüller ',
    rules_ewards: 'Kurallar ve Ödüller ',
    global_star_ranking: 'Global Yıldız Sıralaması',
    global_star_ranking_description1: '1. Ülkenizi en üste taşımak için etkinlik hediyeleri gönderin. ',
    global_star_ranking_description2:
      '2. Etkinlik sırasında ülkenizin kullanıcıları tarafından gönderilen etkinlik hediyesi sayısına göre sıralama. ',
    global_star_rewards: 'Global Yıldız Ödülleri',
    global_star_rewards_description1:
      '1. Etkinlik sırasında ne kadar çok etkinlik hediyesi gönderirseniz o kadar fazla ödüller alırsınız. ',
    global_star_rewards_description2:
      '2. Global Yıldız sıralamasında ilk 3 ülkeye en çok katkıda bulunan kullanıcılar madalya, VIP, şapka, araç giriş efekti ve diğer ödülleri alabilirler.',
    national_star_ranking: ' Ulusal Yıldız Sıralaması ',
    national_star_ranking_description1: '1. Etkinlik sırasında verilen hediye sayısına göre sıralama. ',
    Other: 'Diğer ',
    Other_description1:
      '1. Platform, bir kullanıcının düzenlemeleri ihlal ettiğini tespit ederse kullanıcının etkinlik verilerini silme hakkına sahiptir. ',
    Other_description2: '2. Yayya bu olayı yorumlama hakkını saklı tutar.\n Bu olayın Apple ile hiçbir ilgisi yoktur. ',
    top1_country: 'TOP1 Ülke ',
    top2_country: 'TOP2 Ülke ',
    top3_country: 'TOP3 Ülke ',
    top1_user: 'TOP1 Kullanıcı',
    top2_user: 'TOP2 Kullanıcı',
    top3_user: 'TOP3 Kullanıcı',
    cheer_rewards_description1: 'Görevi tamamlamak için aşağıdaki hediyeyi gönderin ',
    current_gift_quantity: 'Verilen mevcut hediye miktarı: {0}',
    cheer_rewards_description2: 'Aşağıdaki ödüllerin kilidini açmak için {0} mevcut hediyeyi gönderin ',
    receive: 'Almak',
    received: 'Alındı',
    certificate: 'Sertifika',
    certificate_description1: 'Sayın {0}:',
    certificate_description2:
      'Tutkunuz ve bağlılığınız ulusal zaferin parlayan ışığıdır. Bu tutkulu rekabette, desteğiniz ülkenize olan derin sevginizi ve sağlam bağlılığınızı ortaya koydu. Şu anda bu tutku ve şeref hediyesini sizlere büyük bir saygıyla sunuyoruz. ',
    certificate_description3:
      "Elinizdeki ulusal bayrak her zaman kalbinizde dalgalansın ve size {0}'ın şanına katkıda bulunmaya devam etmeniz için ilham versin!",
    toast_msg: 'Toplama başarısız oldu, lütfen daha sonra tekrar deneyin',
    no_gift: 'Bu etkinlik yakında ülkenizde başlayacak, lütfen bizi takip etmeye devam edin~',
    days: '{0} gün',
    stage_1: 'Aşama1',
    stage_2: 'Aşama2',
    stage_3: 'Aşama3',
    time_days: 'Gün',
    hours: 'Saat',
    minutes: 'Dakika',
    seconds: 'Saniye'
  },
  pt: {
    event_coming_soon: 'Este evento será lançado em breve no seu país, fique ligado~',
    global_star: 'Estrela Global',
    hoby_2024_global_star: 'HOBY 2024 Estrela Global',
    last_week_global_star: 'Estrela global da semana passada',
    event_gift: 'Presente da Atividade',
    event_gift_description1: 'Envie o presente do seu país para torcer pelo seu país',
    national_star: 'Estrela Nacional',
    cheer_rewards: 'Recompensas de Torcida<br />',
    cheer_rewards2: 'Recompensas de Torcida',
    this_week_global_star: 'Estrela Global desta semana',
    this_week_national_star: 'Estrela Nacional desta semana',
    rules: 'Regras',
    rewards: 'Recompensas',
    rules_ewards: 'Regras & Recompensas',
    global_star_ranking: 'Ranking Estrela Global',
    global_star_ranking_description1: '1. Envie presentes do evento para torcer pelo seu país.',
    global_star_ranking_description2:
      '2. O ranking é baseado no número de presentes do evento enviados pelos usuários nacionais durante o evento.',
    global_star_rewards: 'Recompensas Estrela Global',
    global_star_rewards_description1:
      '1. Quanto mais presentes do evento você enviar durante o evento, mais generosas serão as recompensas.',
    global_star_rewards_description2:
      '2. Usuários que fizerem contribuições notáveis nos 3 primeiros países do ranking Estrela Global podem receber medalhas, VIP, acessórios, carros e outras recompensas.',
    national_star_ranking: 'Ranking Estrela Nacional',
    national_star_ranking_description1: '1. Ranking baseado no número de presentes dados durante o evento.',
    Other: 'Outro',
    Other_description1:
      '1. Se a plataforma detectar que um usuário violou as regras, a plataforma tem o direito de excluir os dados da atividade do usuário.',
    Other_description2:
      '2. A Yayya reserva-se o direito de interpretar este evento. Este evento não tem relação com a Apple.',
    top1_country: 'TOP1 País',
    top2_country: 'TOP2 País',
    top3_country: 'TOP3 País',
    top1_user: 'TOP1 Usuário',
    top2_user: 'TOP2 Usuário',
    top3_user: 'TOP3 Usuário',
    cheer_rewards_description1: 'Envie o seguinte presente para completar a torcida',
    current_gift_quantity: 'Quantidade atual de presentes enviados: {0}',
    cheer_rewards_description2: 'Envie {0} presentes atuais para desbloquear as recompensas abaixo',
    receive: 'Receber',
    received: 'Recebido',
    certificate: 'Certificado',
    certificate_description1: 'Caro {0}:',
    certificate_description2:
      'Sua paixão e dedicação são a luz brilhante da glória nacional. Nesta competição apaixonada, suas ações demonstraram seu profundo amor e firme apoio ao país. Neste momento, apresentamos este presente de torcida e glória a você com grande respeito.',
    certificate_description3:
      'Que a bandeira nacional em suas mãos sempre voe em seu coração e o inspire a continuar contribuindo para a glória de {0}!',
    toast_msg: 'Falha ao coletar, por favor, tente novamente mais tarde',
    no_gift: 'Este evento será lançado em breve no seu país, fique ligado~',
    days: '{0} dias',
    stage_1: 'Fase1',
    stage_2: 'Fase2',
    stage_3: 'Fase3',
    time_days: 'Dias',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos'
  },
  id: {
    event_coming_soon: 'Acara ini akan segera diluncurkan di negara Anda, harap tunggu sebentar~',
    global_star: 'Bintang Global',
    hoby_2024_global_star: 'Bintang Global HOBY 2024',
    last_week_global_star: 'Bintang Global minggu lalu',
    event_gift: 'Hadiah Acara',
    event_gift_description1: 'Kirim hadiah negara Anda untuk mendukung negara Anda',
    national_star: 'Bintang Nasional',
    cheer_rewards: 'Dukungan<br />Hadiah',
    cheer_rewards2: 'Hadiah Dukungan',
    this_week_global_star: 'Bintang Global minggu ini',
    this_week_national_star: 'Bintang Nasional minggu ini',
    rules: 'Aturan',
    rewards: 'Hadiah',
    rules_ewards: 'Aturan & Hadiah',
    global_star_ranking: 'Peringkat Bintang Global',
    global_star_ranking_description1: '1. Kirim hadiah acara untuk mendukung negara Anda.',
    global_star_ranking_description2:
      '2. Peringkat berdasarkan jumlah hadiah acara yang dikirim oleh pengguna domestik selama acara.',
    global_star_rewards: 'Hadiah Bintang Global',
    global_star_rewards_description1:
      '1. Semakin banyak hadiah acara yang Anda kirimkan selama acara, semakin banyak hadiah yang akan Anda dapatkan.',
    global_star_rewards_description2:
      '2. Pengguna yang memberikan kontribusi luar biasa di 3 negara teratas di peringkat Bintang Global dapat menerima medali, VIP, penutup kepala, mobil, dan hadiah lainnya.',
    national_star_ranking: 'Peringkat Bintang Nasional',
    national_star_ranking_description1: '1. Peringkat berdasarkan jumlah hadiah yang diberikan selama acara.',
    Other: 'Lainnya',
    Other_description1:
      '1. Jika platform menemukan bahwa seorang pengguna telah melanggar peraturan, platform berhak menghapus data aktivitas pengguna.',
    Other_description2: '2. Yayya berhak untuk menafsirkan acara ini. Acara ini tidak ada kaitannya dengan Apple.',
    top1_country: 'Negara TOP1',
    top2_country: 'Negara TOP2',
    top3_country: 'Negara TOP3',
    top1_user: 'Pengguna TOP1',
    top2_user: 'Pengguna TOP2',
    top3_user: 'Pengguna TOP3',
    cheer_rewards_description1: 'Kirim hadiah berikut untuk menyelesaikan dukungan',
    current_gift_quantity: 'Jumlah hadiah yang diberikan saat ini: {0}',
    cheer_rewards_description2: 'Kirim {0} hadiah saat ini untuk membuka hadiah berikutnya',
    receive: 'Terima',
    received: 'Diterima',
    certificate: 'Sertifikat',
    certificate_description1: 'Kepada {0}:',
    certificate_description2:
      'Semangat dan dedikasi Anda adalah cahaya yang bersinar dari kejayaan nasional. Dalam kompetisi yang penuh semangat ini, tindakan Anda telah menunjukkan cinta yang mendalam dan dukungan yang teguh untuk negara. Saat ini, kami memberikan hadiah dukungan dan kejayaan ini kepada Anda dengan penuh rasa hormat.',
    certificate_description3:
      'Semoga bendera negara di tangan Anda selalu berkibar di hati Anda dan menginspirasi Anda untuk terus memberikan kontribusi pada kejayaan {0}!',
    toast_msg: 'Gagal mengumpulkan, harap coba lagi nanti',
    no_gift: 'Acara ini akan segera diluncurkan di negara Anda, harap tunggu sebentar~',
    days: '{0} hari',
    stage_1: 'Tahap 1',
    stage_2: 'Tahap 2',
    stage_3: 'Tahap 3',
    time_days: 'Hari',
    hours: 'Jam',
    minutes: 'Menit',
    seconds: 'Detik'
  },
  uz: {
    event_coming_soon: 'Ushbu tadbir yaqinda sizning mamlakatingizda boshlanadi, shuning uchun bizni kuzatib boring ）',
    global_star: 'Jahon yulduzi',
    hoby_2024_global_star: 'HOBY 2024 jahon yulduzi',
    last_week_global_star: "O'tgan hafta jahon yulduzi",
    event_gift: "Tadbir sovg'asi",
    event_gift_description1: "Mamlakatingizni xursand qilish uchun mamlakatingizga sovg'a yuboring",
    national_star: 'Milliy Yulduz',
    cheer_rewards: "Qo'llab-quvvatlash <br /> mukofotlari",
    cheer_rewards2: "Motivatsiya Sovg'alari",
    this_week_global_star: 'Bu haftaning jahon yulduzi',
    this_week_national_star: 'Bu haftaning milliy yulduzi',
    rules: 'Qoidalar',
    rewards: "Sovg'alar",
    rules_ewards: "Qoidalar va Sovg'alar",
    global_star_ranking: 'Dunyo yulduzlari reytingi',
    global_star_ranking_description1: "1. Reyting tadbir davomida yuborilgan tadbir sovg'alari soniga asoslanadi.",
    global_star_ranking_description2:
      "2. Reyting tadbir davomida milliy foydalanuvchilar tomonidan yuborilgan tadbir sovg'alari soniga asoslanadi.",
    global_star_rewards: 'Jahon yulduzi mukofotlari',
    global_star_rewards_description1:
      "1. Tadbir davomida tadbir sovg'alarini qanchalik ko'p yuborsangiz, shunchalik saxiy mukofotlarga ega bo'lasiz.",
    global_star_rewards_description2:
      "2. Jahon yulduzlari reytingining eng yaxshi 3 mamlakatiga ajoyib hissa qo'shgan foydalanuvchilar medallar, VIP, bosh kiyimlar, haydovchilar va boshqa mukofotlarga ega bo'lishlari mumkin.",
    national_star_ranking: 'Milliy Yulduz Reytingi',
    national_star_ranking_description1: "1. Tadbir davomida yuborilgan sovg'alar soniga asoslangan reyting.",
    Other: 'Boshqa',
    Other_description1:
      "1. Agar platforma foydalanuvchi qoidalarni buzganligini aniqlasa, platforma foydalanuvchi hodisasi ma'lumotlarini o'chirish huquqiga ega.",
    Other_description2:
      "2. Yayya ushbu tadbirni talqin qilish huquqini o'zida saqlab qoladi. Ushbu tadbir Apple bilan hech qanday aloqasi yo'q.",
    top1_country: 'Top-1 mamlakat',
    top2_country: 'Top-2 mamlakat',
    top3_country: 'Top-3 mamlakat',
    top1_user: 'Top-1 foydalanuvchi',
    top2_user: 'Top-2 foydalanuvchi',
    top3_user: 'Top-3 foydalanuvchi',
    cheer_rewards_description1: "Tabrikni yakunlash uchun keyingi sovg'ani yuboring",
    current_gift_quantity: "Sovg'alarning joriy soni: {0}",
    cheer_rewards_description2: "Quyidagi mukofotlarni ochish uchun joriy sovg'alarni {0} yuboring",
    receive: 'Olish',
    received: 'Olingan',
    certificate: 'Sertifikat',
    certificate_description1: 'Qimmat {0}:',
    certificate_description2:
      "Sizning ishtiyoqingiz va fidoyiligingiz milliy shon-Shuhratning yorqin nuridir. Ushbu ehtirosli musobaqada sizning harakatlaringiz mamlakatga bo'lgan chuqur sevgingizni va uni qat'iy qo'llab-quvvatlashingizni namoyish etdi. Shu payt biz sizga ushbu qarsaklar va shon-sharaf sovg'asini katta hurmat bilan taqdim etamiz.",
    certificate_description3:
      "Sizning qo'lingizda davlat bayrog'i doimo yuragingizda rivojlanib borsin va sizni {0} shon-shuhratiga hissa qo'shishni davom ettirishga ilhomlantirsin!",
    toast_msg: "Yig'ish muvaffaqiyatsiz bo'ldi, iltimos, keyinroq qayta urinib ko'ring",
    no_gift: 'Bu tadbir tez orada sizning mamlakatingizda boshlanadi, iltimos, kuzatib boring~',
    days: '{0} kunlar',
    stage_1: 'Bosqich1',
    stage_2: 'Bosqich2',
    stage_3: 'Bosqich3',
    time_days: 'Kunlar',
    hours: 'Soatlar',
    minutes: 'Daqiqalar',
    seconds: 'Sekundlar'
  },
  ru: {
    event_coming_soon: 'Это мероприятие скоро стартует в вашей стране, так что следите за обновлениями ）',
    global_star: 'Мировая звезда',
    hoby_2024_global_star: 'Мировая звезда HOBY 2024',
    days: '{0} дней',
    hours: 'Часы',
    minutes: 'Минуты',
    seconds: 'Секунды',
    last_week_global_star: 'Мировая звезда прошлой недели',
    event_gift: 'Подарок мероприятия',
    event_gift_description1: 'Отправьте подарок своей страны, чтобы поболеть за свою страну',
    national_star: 'Национальная звезда',
    cheer_rewards: 'Награды за поддержку',
    cheer_rewards2: 'Награды за поддержку',
    this_week_global_star: 'Мировая звезда этой недели',
    this_week_national_star: 'Национальная звезда этой недели',
    rules: 'Правила',
    rewards: 'Награды',
    rules_ewards: 'Правила и награды',
    global_star_ranking: 'Мировой звездный рейтинг',
    global_star_ranking_description1: '1. Присылайте подарки мероприятия, чтобы поболеть за свою страну.',
    global_star_ranking_description2:
      '2. Рейтинг основан на количестве подарков мероприятия, отправленных национальными пользователями во время мероприятия.',
    global_star_rewards: 'Награды Мировой звезды',
    global_star_rewards_description1:
      '1. Чем больше подарков мероприятия вы отправите во время мероприятия, тем более щедрые награды получите.',
    global_star_rewards_description2:
      '2. Пользователи, внесшие выдающийся вклад в топ-3 стран рейтинга Мировой звезды, могут получить медали, VIP, головные уборы, драйвы и другие награды.',
    national_star_ranking: 'Национальный звездный рейтинг',
    national_star_ranking_description1:
      '1. Рейтинг основан на количестве подарков мероприятия, отправленных во время мероприятия.',
    Other: 'Другой',
    Other_description1:
      '1. Если платформа обнаружит, что пользователь нарушил правила, платформа имеет право удалить данные о мероприятии пользователя.',
    Other_description2:
      '2. Yayya оставляет за собой право интерпретировать это мероприятие. Это мероприятие не имеет никакого отношения к Apple.',
    top1_country: 'ТОП-1 Страна',
    top2_country: 'ТОП-2 Страна',
    top3_country: 'ТОП-3 Страна',
    top1_user: 'ТОП-1 пользователь',
    top2_user: 'ТОП-2 пользователя',
    top3_user: 'ТОП-3 пользователя',
    cheer_rewards_description1: 'Отправьте следующий подарок, чтобы завершить поздравление',
    current_gift_quantity: 'Текущее количество подарков: {0}',
    cheer_rewards_description2: 'Отправьте {0} текущих подарков, чтобы разблокировать следующие награды',
    receive: 'Получать',
    received: 'Полученный',
    certificate: 'Сертификат',
    certificate_description1: 'Дорогой {0}:',
    certificate_description2:
      'Ваша страсть и преданность делу являются ярким светом национальной славы. В этом страстном соревновании ваши действия продемонстрировали вашу глубокую любовь к стране и твердую поддержку ей. В этот момент мы с большим уважением вручаем вам этот дар аплодисментов и славы.',
    certificate_description3:
      'Пусть национальный флаг в ваших руках всегда развивается в вашем сердце и вдохновляет вас продолжать вносить свой вклад во славу {0}!',
    stage_1: 'Этап 1',
    stage_2: 'Этап 2',
    stage_3: 'Этап 3',
    time_days: 'день'
  },
  fa: {
    event_coming_soon: 'این رویداد به زودی در کشور شما آغاز خواهد شد، لطفاً منتظر بمانید~',
    global_star: 'ستاره جهانی',
    hoby_2024_global_star: 'HOBY 2024 ستاره جهانی',
    last_week_global_star: 'ستاره جهانی هفته گذشته',
    event_gift: 'هدیه فعالیت',
    event_gift_description1: 'هدیه کشور خود را ارسال کنید تا از کشور خود حمایت کنید',
    national_star: 'ستاره ملی',
    cheer_rewards: 'تشویق<br />جوایز',
    cheer_rewards2: 'جوایز تشویق',
    this_week_global_star: 'ستاره جهانی این هفته',
    this_week_national_star: 'ستاره ملی این هفته',
    rules: 'قوانین',
    rewards: 'جوایز',
    rules_ewards: 'قوانین و جوایز',
    global_star_ranking: 'رتبه‌بندی ستارگان جهانی',
    global_star_ranking_description1: '1. هدایا رویداد را ارسال کنید تا از کشور خود حمایت کنید.',
    global_star_ranking_description2:
      '2. رتبه‌بندی بر اساس تعداد هدایا است که کاربران کشور شما در طول رویداد ارسال کرده‌اند.',
    global_star_rewards: 'جوایز ستاره جهانی',
    global_star_rewards_description1: '1. هرچقدر هدیه‌های بیشتری ارسال کنید، جوایز بیشتری خواهید گرفت.',
    global_star_rewards_description2:
      '2. کاربران با مشارکت برجسته در 3 کشور برتر در رتبه‌بندی ستاره جهانی می‌توانند مدال‌ها، VIP، کلاه، ماشین و جوایز دیگر دریافت کنند.',
    national_star_ranking: 'رتبه‌بندی ستارگان ملی',
    national_star_ranking_description1: '1. رتبه‌بندی بر اساس تعداد هدایا است که در طول رویداد ارسال شده است.',
    Other: 'دیگر',
    Other_description1:
      '1. اگر پلتفرم متوجه شود که کاربری قوانین را نقض کرده است، این پلتفرم حق حذف داده‌های فعالیت آن کاربر را دارد.',
    Other_description2:
      '2. Yayya حق تفسیر این رویداد را برای خود محفوظ می‌دارد. این رویداد هیچ ارتباطی با Apple ندارد.',
    top1_country: 'کشور TOP1',
    top2_country: 'کشور TOP2',
    top3_country: 'کشور TOP3',
    top1_user: 'کاربر TOP1',
    top2_user: 'کاربر TOP2',
    top3_user: 'کاربر TOP3',
    cheer_rewards_description1: 'هدیه زیر را ارسال کنید تا تشویق تکمیل شود',
    current_gift_quantity: 'مقدار هدیه جاری ارسال شده: {0}',
    cheer_rewards_description2: 'برای باز کردن جوایز بعدی، {0} هدیه جاری را ارسال کنید',
    receive: 'دریافت',
    received: 'دریافت شده',
    certificate: 'گواهی نامه',
    certificate_description1: 'عزیز {0}:',
    certificate_description2:
      'شور و شوق و تعهد شما روشنایی درخشان افتخار ملی است. در این رقابت پرشور، اقدامات شما علاقه عمیق و حمایت قوی شما از کشور را نشان داده است. در این لحظه، ما این هدیه حمایت و افتخار را با احترام به شما تقدیم می‌کنیم.',
    certificate_description3:
      'امیدواریم پرچم ملی در دستان شما همیشه در دل شما برافراشته باشد و شما را تشویق کند که به ادامه حمایت از افتخار {0} ادامه دهید!',
    toast_msg: 'جمع‌آوری ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    no_gift: 'این رویداد به زودی در کشور شما آغاز خواهد شد، لطفاً منتظر بمانید~',
    days: '{0} روز',
    stage_1: 'مرحله 1',
    stage_2: 'مرحله 2',
    stage_3: 'مرحله 3',
    time_days: 'روزها',
    hours: 'ساعات',
    minutes: 'دقایق',
    seconds: 'ثانیه‌ها'
  },
  ur: {
    event_coming_soon: 'یہ ایونٹ جلد ہی آپ کے ملک میں لانچ کیا جائے گا، براہ کرم انتظار کریں~',
    global_star: 'گلوبل اسٹار',
    hoby_2024_global_star: 'HOBY 2024 گلوبل اسٹار',
    last_week_global_star: 'گزشتہ ہفتے کا گلوبل اسٹار',
    event_gift: 'ایکٹیویٹی گفٹ',
    event_gift_description1: 'اپنے ملک کے لیے گفٹ بھیجیں تاکہ اپنے ملک کی حوصلہ افزائی کی جا سکے',
    national_star: 'نیشنل اسٹار',
    cheer_rewards: 'حوصلہ افزائی<br />انعامات',
    cheer_rewards2: 'حوصلہ افزائی انعامات',
    this_week_global_star: 'اس ہفتے کا گلوبل اسٹار',
    this_week_national_star: 'اس ہفتے کا نیشنل اسٹار',
    rules: 'قواعد',
    rewards: 'انعامات',
    rules_ewards: 'قواعد و انعامات',
    global_star_ranking: 'گلوبل اسٹار رینکنگ',
    global_star_ranking_description1: '1. اپنے ملک کی حوصلہ افزائی کے لیے ایونٹ گفٹس بھیجیں۔',
    global_star_ranking_description2:
      '2. ایونٹ کے دوران ملکی صارفین کی جانب سے بھیجے گئے ایونٹ گفٹس کی تعداد کی بنیاد پر رینکنگ۔',
    global_star_rewards: 'گلوبل اسٹار انعامات',
    global_star_rewards_description1:
      '1. ایونٹ کے دوران آپ جتنی زیادہ ایونٹ گفٹس بھیجیں گے، اتنا ہی زیادہ انعام حاصل کریں گے۔',
    global_star_rewards_description2:
      '2. گلوبل اسٹار رینکنگ کے ٹاپ 3 ممالک میں نمایاں شراکت کرنے والے صارفین میڈلز، VIP، ہیڈ ویئر، گاڑیاں اور دیگر انعامات حاصل کر سکتے ہیں۔',
    national_star_ranking: 'نیشنل اسٹار رینکنگ',
    national_star_ranking_description1: '1. ایونٹ کے دوران دیے گئے گفٹس کی تعداد کی بنیاد پر رینکنگ۔',
    Other: 'دیگر',
    Other_description1:
      '1. اگر پلیٹ فارم کو پتہ چلتا ہے کہ کسی صارف نے قواعد کی خلاف ورزی کی ہے، تو پلیٹ فارم کو صارف کی ایکٹیویٹی ڈیٹا کو حذف کرنے کا حق حاصل ہے۔',
    Other_description2: '2. Yayya کو اس ایونٹ کی تشریح کا حق محفوظ ہے۔ اس ایونٹ کا ایپل سے کوئی تعلق نہیں ہے۔',
    top1_country: 'ٹاپ 1 ملک',
    top2_country: 'ٹاپ 2 ملک',
    top3_country: 'ٹاپ 3 ملک',
    top1_user: 'ٹاپ 1 صارف',
    top2_user: 'ٹاپ 2 صارف',
    top3_user: 'ٹاپ 3 صارف',
    cheer_rewards_description1: 'حوصلہ افزائی مکمل کرنے کے لیے درج ذیل گفٹ بھیجیں',
    current_gift_quantity: 'دیے گئے گفٹس کی موجودہ تعداد: {0}',
    cheer_rewards_description2: 'درج ذیل انعامات کو انلاک کرنے کے لیے {0} موجودہ گفٹس بھیجیں',
    receive: 'وصول کریں',
    received: 'موصول ہو چکا',
    certificate: 'سرٹیفکیٹ',
    certificate_description1: 'پیارے {0}:',
    certificate_description2:
      'آپ کا جوش اور لگن قومی شان کی چمکتی روشنی ہے۔ اس پرجوش مقابلے میں، آپ کے اقدامات نے ملک کے لیے آپ کی گہری محبت اور مضبوط حمایت کا مظاہرہ کیا ہے۔ اس لمحے، ہم آپ کو یہ حوصلہ افزائی اور شان کا تحفہ بڑے احترام کے ساتھ پیش کرتے ہیں۔',
    certificate_description3:
      'آپ کے ہاتھ میں قومی پرچم ہمیشہ آپ کے دل میں لہرائے اور آپ کو {0} کی شان کے لیے مسلسل تعاون کرنے کی ترغیب دے!',
    toast_msg: 'وصول کرنے میں ناکامی، براہ کرم بعد میں کوشش کریں',
    no_gift: 'یہ ایونٹ جلد ہی آپ کے ملک میں لانچ کیا جائے گا، براہ کرم انتظار کریں~',
    days: '{0} دن',
    stage_1: 'اسٹیج 1',
    stage_2: 'اسٹیج 2',
    stage_3: 'اسٹیج 3',
    time_days: 'دن',
    hours: 'گھنٹے',
    minutes: 'منٹ',
    seconds: 'سیکنڈز'
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/lang.js